import { Avatar, Status, UserStatus } from "@chatscope/chat-ui-kit-react";
import { Image } from "react-img-placeholder";
import { HTMLAttributes } from "react";

export const AvatarWithPlaceholder = ({
	displayName,
	photoUri,
	placeholderUri,
	status,
	...rest
}: HTMLAttributes<HTMLDivElement> & {
	displayName?: string;
	photoUri?: string | null;
	placeholderUri?: string | null;
	status?: UserStatus;
	onClick?: () => void;
}) => {
	return (
		<Avatar {...rest} title={displayName}>
			<Image
				src={photoUri}
				alt={displayName}
				placeholder={
					<img src={placeholderUri ?? undefined} alt={displayName} />
				}
			/>
			{typeof status === "string" && <Status status={status} size="md" />}
		</Avatar>
	);
};
